import PartnerInfoConstants from 'Shared/constants/PartnerInfo.constants';
import * as PiCoreAPI from '../api/PiCore.api';

import { AxiosResponse } from 'axios';

export const getPartnerInfoSuccess = payload => ({
  type: PartnerInfoConstants.Actions.GET_PARTNER_INFO_SUCCESS,
  payload,
});

export const getPartner =
  ({ companyGuid }: { companyGuid: string }) =>
  dispatch => {
    return PiCoreAPI.getPartnerInfo({ companyGuid })
      .then((response: AxiosResponse) => {
        dispatch(getPartnerInfoSuccess(response.data));
        return response;
      })
      .catch(error => {
        return error.response;
      });
  };
